import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { SITE, waLink } from "../config/site";
import { SERVICES } from "../data/services";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-night" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 lg:grid-cols-12 lg:px-8">
      <div className="lg:col-span-4">
        <Link to="/" className="flex items-center gap-3" data-testid="footer-logo">
          <img
            src={SITE.logo}
            alt="SparkGrid Solutions logo"
            className="h-11 w-11 rounded-lg object-cover object-[50%_18%] ring-1 ring-white/15"
          />
          <span className="font-syne text-xl font-bold text-white">
            Spark
            <span className="bg-gradient-to-r from-spark to-ember bg-clip-text text-transparent">Grid</span>
          </span>
        </Link>
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
          A Mumbai-based software studio crafting websites, web apps, mobile apps and crypto products.
          <span className="mt-2 block font-mono text-xs uppercase tracking-[0.25em] text-spark">
            {SITE.tagline}
          </span>
        </p>
        <a
          href={waLink("Hello SparkGrid Solutions! I'd like to discuss a project.")}
          target="_blank"
          rel="noreferrer"
          data-testid="footer-whatsapp-btn"
          className="mt-6 inline-flex items-center gap-2 rounded-full border border-wa/40 bg-wa/10 px-4 py-2 text-sm font-semibold text-wa transition-colors hover:bg-wa hover:text-night"
        >
          <WhatsAppIcon className="h-4 w-4" /> Chat on WhatsApp
        </a>
      </div>

      <div className="lg:col-span-3">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">Services</p>
        <ul className="mt-5 space-y-3">
          {SERVICES.map((s) => (
            <li key={s.slug}>
              <Link
                to={`/services/${s.slug}`}
                data-testid={`footer-service-${s.slug}`}
                className="text-sm text-slate-400 transition-colors hover:text-spark"
              >
                {s.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="lg:col-span-2">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">Company</p>
        <ul className="mt-5 space-y-3">
          <li>
            <Link to="/" data-testid="footer-link-home" className="text-sm text-slate-400 transition-colors hover:text-spark">Home</Link>
          </li>
          <li>
            <Link to="/about" data-testid="footer-link-about" className="text-sm text-slate-400 transition-colors hover:text-spark">About Us</Link>
          </li>
          <li>
            <Link to="/contact" data-testid="footer-link-contact" className="text-sm text-slate-400 transition-colors hover:text-spark">Contact Us</Link>
          </li>
        </ul>
      </div>

      <div className="lg:col-span-3">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">Reach Us</p>
        <ul className="mt-5 space-y-4 text-sm text-slate-400">
          <li className="flex gap-3">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-ember" />
            <span data-testid="footer-address">{SITE.addressShort}</span>
          </li>
          <li>
            <a href={SITE.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 transition-colors hover:text-spark">
              <Phone className="h-4 w-4 shrink-0 text-ember" /> {SITE.phoneDisplay}
            </a>
          </li>
          <li>
            <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="flex items-center gap-3 transition-colors hover:text-spark">
              <Mail className="h-4 w-4 shrink-0 text-ember" /> {SITE.email}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-6">
      <p className="text-center text-xs text-slate-500">
        © {new Date().getFullYear()} {SITE.name}. All rights reserved. Crafted in Mumbai, India.
      </p>
    </div>
  </footer>
);
